import {
  ActionIcon,
  Flex,
  Loader,
  ScrollArea,
  Table,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { closeModal } from "@mantine/modals";
import { memo, useMemo } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import {
  CustomReportInput,
  useGetAgreementReportQuery,
} from "src/generated/graphql";
import { ModalId } from "src/utils/constants";
import { ISOformatedDateTime } from "src/utils/dateHelper";

const header = [
  "Location",
  "Member Name",
  "Member Status",
  "Agreement Number",
  "Agreement Name",
  "Begin Date",
  "Expiration Date",
  "Frequency",
  "Term",
  "isRenewal",
  "isMembership",
  "Last Visit Date",
];

type ITableReport = {
  values: CustomReportInput;
};

function TableReport({ values }: ITableReport) {
  const theme = useMantineTheme();
  let color = theme.colors.secondaryTextColor[6];
  const { data, loading } = useGetAgreementReportQuery({
    variables: { data: values },
  });

  const rows = useMemo(
    () =>
      data?.agreementReport.map((e) => (
        <tr key={e.id}>
          <td>{e.location.name}</td>
          <td>
            {e.client.user.firstName} {e.client.user.lastName}
          </td>
          <td>{e.client.memberStatus}</td>
          <td>{e.agreement.version}</td>
          <td>{e.agreement.name}</td>
          <td>{e.termStart ? ISOformatedDateTime(e.termStart) : "N/A"}</td>
          <td>{e.termEnd ? ISOformatedDateTime(e.termEnd) : "N/A"}</td>
          <td>{e.agreement.paymentFrequency}</td>
          <td>{e.agreement.termValue}</td>
          <td>{e.isAutoRenew ? "true" : "false"}</td>
          <td>{e.agreement.isMembership ? "true" : "false"}</td>
          <td>
            {e.client.lastVisitDate
              ? ISOformatedDateTime(e.client.lastVisitDate)
              : "N/A"}
          </td>
        </tr>
      )),
    [data?.agreementReport]
  );

  const handleBack = () => {
    closeModal(ModalId.ReportView);
  };

  const headerMemo = useMemo(() => {
    return header.map((e) => <th>{e}</th>);
  }, []);

  return (
    <Flex direction={"column"} px={"sm"}>
      <ActionIcon
        mt={"md"}
        onClick={handleBack}
        size={"lg"}
        sx={{
          "&:hover": {
            backgroundColor: theme.colors.secondary[6],
          },
        }}
      >
        <IoIosArrowRoundBack color={color} size={32} />
      </ActionIcon>

      {!rows?.length ? (
        <Flex justify={"center"} align={"center"} mt={"lg"}>
          {loading ? (
            <Loader />
          ) : (
            <Text fw={"bold"} size={"xl"}>
              No Record Found
            </Text>
          )}
        </Flex>
      ) : (
        <ScrollArea
          style={{ height: "75vh" }}
          type="auto"
          px={"sm"}
          offsetScrollbars
        >
          <Table>
            <thead>
              <tr>{headerMemo}</tr>
            </thead>

            <tbody>{rows}</tbody>
          </Table>
        </ScrollArea>
      )}
    </Flex>
  );
}

export default memo(TableReport);
